module.exports = __webpack_public_path__ + "img/icon-skip-end-active.4a53a476.svg";